import Vue from 'vue';

Vue.directive('hide-but-keep', (el, binding) => {
	el.style.opacity = binding.value ? 0 : 1;
});
